import { render, staticRenderFns } from "./moneyBack_detail.vue?vue&type=template&id=764c39c8&scoped=true"
import script from "./moneyBack_detail.vue?vue&type=script&lang=js"
export * from "./moneyBack_detail.vue?vue&type=script&lang=js"
import style0 from "./moneyBack_detail.vue?vue&type=style&index=0&id=764c39c8&prod&lang=css"
import style1 from "./moneyBack_detail.vue?vue&type=style&index=1&id=764c39c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c39c8",
  null
  
)

export default component.exports